import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Injectable } from '@angular/core';
import { map, take, skipWhile } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  /**
   * Checks if user can logged in, if logged in return true,
   * else if not logged in redirect to login page
   * @param route 
   * @param state 
   * @returns  
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.isAuthenticated.pipe(
      skipWhile(value => value === null),
      take(1),
      map(token => {
        const isAuth = !!token;
        if (isAuth) {
          // console.log(`Auth guard: MOZE`);
          return true;
        }
        // console.log('Auth guard: NE MOZE');
        // return this.router.createUrlTree(['/login']);
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      })
      // tap(isAuth => {
      //   if (!isAuth) {
      //     this.router.navigate(['/auth']);
      //   }
      // })
    );
  }
}
